interface Option {
  id: string;
  title: string;
  colorClassName?: string;
}

interface ToggleableRadioGroupProps {
  value: string;
  onChange: (val: string) => void;
  options: Option[];
  className?: string;
}

const ToggleableRadioGroup = ({ value, onChange, options, className }: ToggleableRadioGroupProps) => {
  return (
    <div className={`flex gap-4 ${className || ""}`}>
      {options.map((opt) => {
        const isSelected = value === opt.id;
        return (
          <label
            key={opt.id}
            className="flex items-center gap-2 cursor-pointer select-none"
            onClick={() => {
              if (isSelected) {
                onChange("");
              } else {
                onChange(opt.id);
              }
            }}
          >
            <span
              className={`
                h-4 w-4 rounded-full border border-gray-400 flex items-center justify-center
              `}
            >
              {isSelected && <span className={`h-2 w-2 rounded-full ${opt.colorClassName}`}></span>}
            </span>

            <span className="text-xs">{opt.title}</span>
          </label>
        );
      })}
    </div>
  );
};

export default ToggleableRadioGroup;
